var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useField } from 'react-final-form';
import { FFDropdown, FFTextInput } from '@leapfinance/geebee-component-library';
import { isFalsy } from '../../../../utils/common';
import { getModifiedGradeLabel } from '../utils';
var BachelorsExamCFFilter = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var gradingScheme = useField(props.gradingSchemeFieldName);
    return (React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-2  [&>.lfc-component-container]:flex [&>.lfc-component-container]:flex-col [&>.lfc-component-container]:gap-1  [&>.lfc-component-container>.MuiTypography-root]:m-0" },
        React.createElement(FFDropdown, { fieldProps: { name: props.gradingSchemeFieldName }, componentProps: {
                disableClearable: true,
                textInputProps: {
                    label: 'Grading Scheme',
                    placeholder: 'Select'
                },
                options: (_a = props === null || props === void 0 ? void 0 : props.gradeSystemOptions) !== null && _a !== void 0 ? _a : [],
                renderOption: function (props, option) { var _a, _b; return React.createElement("li", __assign({}, props), (_b = (_a = getModifiedGradeLabel(option)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : ''); },
                size: 'small'
            } }),
        React.createElement(FFTextInput, { fieldProps: { name: props.gradeFieldName }, componentProps: {
                type: 'number',
                label: 'Grade',
                placeholder: 'Enter grade',
                disabled: isFalsy((_c = (_b = gradingScheme === null || gradingScheme === void 0 ? void 0 : gradingScheme.input) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.value),
                size: 'small',
                helperText: isFalsy((_e = (_d = gradingScheme === null || gradingScheme === void 0 ? void 0 : gradingScheme.input) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.value) ? 'Please Select Grading Scheme' : ''
            } }),
        props.renderBacklog && (props === null || props === void 0 ? void 0 : props.backlogsFieldName) && (React.createElement(FFTextInput, { fieldProps: { name: props.backlogsFieldName }, componentProps: {
                type: 'number',
                label: 'Total no.of Backlogs',
                placeholder: 'Enter number of backlogs',
                size: 'small'
            } })),
        (props === null || props === void 0 ? void 0 : props.naacFieldName) ? (React.createElement(FFDropdown, { fieldProps: { name: props.naacFieldName }, componentProps: {
                disableClearable: false,
                textInputProps: {
                    label: 'University NAAC',
                    placeholder: 'Select'
                },
                options: (_f = props === null || props === void 0 ? void 0 : props.naacOptions) !== null && _f !== void 0 ? _f : [],
                size: 'small'
            } })) : null));
};
export default BachelorsExamCFFilter;
//# sourceMappingURL=BachelorsExamCFFilter.js.map